module.exports = __webpack_public_path__ + "img/bk_mobile.8f3d1b95.jpg";